import { zodResolver } from "@hookform/resolvers/zod";
import { useForm, Controller } from "react-hook-form";
import { schema } from "./schema";
import { endOfMonth, startOfMonth } from "date-fns";

export const IndexHooks = ({ options, handleSubmitModalFilter, filterData }) => {
	const parameterDefault = options?.parametersFilter?.[0];
	const value = parameterDefault?.value;
	const label = parameterDefault?.label;

	const parameterDefaultDate = options?.parametersDate?.[0];
	const valueDate = parameterDefaultDate?.value;
	const labelDate = parameterDefaultDate?.label;

	const hasParam = options.hasParam !== undefined ? options.hasParam : true;

	const {
		handleSubmit,
		register,
		watch,
		setFocus,
		setValue,
		formState: { errors, isSubmitting },
		control,
	} = useForm({
		mode: "onSubmit",
		resolver: zodResolver(schema),
		defaultValues: {
			dtIni: startOfMonth(new Date()),
			dtFim: endOfMonth(new Date()),
			param: { value, label },
			paramDate: { value: valueDate, label: labelDate },
			salesType: "",
			clientType: "",
			situacaoCompra: "S", // Padrao: JA COMPROU
			paramValue: "30", // Padrao: 30 dias
			active: true,
		},
	});

	const paramSelected = watch("param");

	const handleOnSubmit = async (data) => {
		const showTime = options.showTime;
		const hasActive = options.hasActive;

		const filterListFormated = {};

		Object.entries(data).forEach(([key, value]) => {
			let displayValue = value;
			
			// Se o valor estiver vazio mas formos o paramValue, mostramos 30 no header (fallback do server)
			if (!displayValue && key === "paramValue") {
				displayValue = "30";
			}

			if (displayValue !== undefined && displayValue !== null && displayValue !== "") {
				if (key === "param") {
					if (hasParam) {
						filterListFormated["param"] = {
							label: "Parametro",
							value: displayValue.label,
						};
					}
				} else if (key === "paramDate") {
					filterListFormated["paramDate"] = {
						label: "Parametro",
						value: displayValue.label,
					};
				} else if (key === "paramValue") {
					filterListFormated["paramValue"] = {
						label: "Valor:",
						value: displayValue,
					};
				} else if (key === "clientType") {
					filterListFormated["clientType"] = {
						label: "Tipo de Cliente",
						value: displayValue,
					};
				} else if (key === "situacaoCompra") {
					filterListFormated["situacaoCompra"] = {
						label: "Situação",
						value: displayValue === "S" ? "JÁ COMPROU" : displayValue === "N" ? "NUNCA COMPROU" : "TODOS",
					};
				} else if (key === "active") {
					if (hasActive) {
						filterListFormated["active"] = {
							label: "Ativo",
							value: displayValue ? "SIM" : "NAO",
						};
					}
				} else if (displayValue instanceof Date) {
					if (showTime) {
						filterListFormated[key] = {
							label: key === "dtIni" ? "Data Inicial" : key === "dtFim" ? "Data Final" : "Data",
							value: displayValue.toLocaleString("pt-BR"),
						};
					}
				} else {
					filterListFormated[key] = {
						label: key,
						value: displayValue,
					};
				}
			}
		});

		await handleSubmitModalFilter(filterListFormated, data);
	};

	return {
		errors,
		isSubmitting,
		register,
		handleSubmit,
		handleOnSubmit,
		paramSelected,
		setFocus,
		control,
		Controller,
		setValue,
		hasParam,
	};
};
